export default __webpack_public_path__ + "static/media/icon-close-red.fc0e9b0a.svg";